import { Modal } from '@palmetto/palmetto-components';

export interface ExportAcknowledgementModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const ExportAcknowledgementModal = ({ isOpen, handleClose }: ExportAcknowledgementModalProps) => (
  <Modal isOpen={isOpen} onDismiss={handleClose} ariaLabelledBy="export-acknowledgement-modal">
    <Modal.Header id="export-acknowledgement-modal" title="Export Request Received" onDismiss={handleClose} />
    <Modal.Body>
      <p>
        Export request has been submitted. You will receive an email when the export is complete. The data that will
        be included in your CSV export will be the most up-to-date information based upon recent activity.
      </p>
    </Modal.Body>
  </Modal>
);
